export default __webpack_public_path__ + "static/media/ID_ANDY.ac487d0e.jpg";